(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tibhelper-injury-calculator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tibhelper-injury-calculator')) {
    class TibhelperInjuryCalculator extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        const copy = this.querySelector('[data-copy]');
        if (!copy) return;
        this.copy = JSON.parse(copy.textContent);
        this.initialized = true;
        this.form = this.querySelector('[data-main-form]');
        this.querySelector('[data-interactive]').hidden = false;
        this.form.addEventListener('submit', event => {
          event.preventDefault();
          this.calculate();
        });
        this.form.addEventListener('input', () => this.clearResult());
        this.form.addEventListener('change', () => this.clearResult());
        this.querySelector('[data-guide-preview]').addEventListener('click', () => {
          const panel = this.querySelector('[data-signup]');
          panel.hidden = !panel.hidden;
          this.querySelector('[data-guide-preview]').setAttribute('aria-expanded', String(!panel.hidden));
        });
      }

      clearResult() {
        this.selection = null;
        this.querySelector('[data-result]').hidden = true;
        this.querySelector('[data-empty]').hidden = false;
        this.querySelector('[data-guide]').hidden = true;
        this.querySelector('[data-error]').hidden = true;
        for (const field of this.form.querySelectorAll('[aria-invalid]')) field.removeAttribute('aria-invalid');
      }

      format(value, variables) {
        return value.replace(/\{(\w+)\}/g, (match, key) => Object.hasOwn(variables, key) ? String(variables[key]) : match);
      }

      write(selector, value) {
        this.querySelector(selector).textContent = value;
      }

      calculate() {
        const sportField = this.form.elements.sport;
        const injuryField = this.form.elements.injury;
        const sport = sportField.value;
        const injury = injuryField.value;
        const sports = ['track', 'track_outdoor', 'cross_country', 'soccer', 'football', 'basketball', 'volleyball', 'runner', 'gym', 'other'];
        const errors = [];
        if (!sports.includes(sport)) errors.push(sportField);
        if (!['shin', 'hip'].includes(injury)) errors.push(injuryField);
        this.clearResult();
        if (errors.length) {
          for (const field of errors) field.setAttribute('aria-invalid', 'true');
          this.querySelector('[data-error]').hidden = false;
          errors[0].focus();
          return;
        }

        const profileId = sport === 'soccer' && injury === 'hip' ? 'soccer' : injury;
        const profiles = {
          shin: {minWeeks: 4, maxWeeks: 6, source: 'https://www.sportsmedtoday.com/shin-splints-va-32.htm'},
          hip: {mode: 'recurrence', source: 'https://pubmed.ncbi.nlm.nih.gov/28745561/'},
          soccer: {minWeeks: 3, maxWeeks: 3, source: 'https://link.springer.com/article/10.1186/s40798-024-00738-0/tables/3'}
        };
        const schoolCalendar = 'https://www.wiaawi.org/Portals/0/PDF/Calendars/extendeddates.pdf';
        const seasons = {
          track: {weeks: 14, source: 'https://www.mpssaa.org/sports/indoor-track-field/state-championships/mpssaa-indoor-track-state-championships-central/'},
          track_outdoor: {weeks: 13, source: schoolCalendar},
          cross_country: {weeks: 11, source: schoolCalendar},
          soccer: {weeks: 13, source: schoolCalendar},
          football: {weeks: 16, source: schoolCalendar},
          basketball: {weeks: 18, source: schoolCalendar},
          volleyball: {weeks: 12, source: schoolCalendar}
        };
        this.selection = {sport, injury, profileId, profile: profiles[profileId], season: seasons[sport] || null};
        const evidence = this.copy.evidence;
        this.write('[data-summary]', sportField.selectedOptions[0].textContent + ' / ' + injuryField.selectedOptions[0].textContent);
        this.write('[data-evidence-claim]', evidence[profileId + '_claim']);
        this.write('[data-context]', evidence[profileId + '_context']);
        this.write('[data-relevance]', this.copy.relevance[sport]);
        const source = this.querySelector('[data-source]');
        source.href = profiles[profileId].source;
        source.textContent = evidence[profileId + '_citation'];
        this.querySelector('[data-result] details').open = false;
        this.querySelector('[data-result]').hidden = false;
        this.querySelector('[data-empty]').hidden = true;
        this.showGuide();
        this.showImpact();
        this.focusResult();
      }

      showImpact() {
        const {sport, profileId, profile, season} = this.selection;
        const result = this.copy.result;
        const figures = this.querySelector('[data-figures]');
        const isRecurrence = profile.mode === 'recurrence';
        figures.hidden = false;
        this.querySelector('[data-calendar]').hidden = isRecurrence || !season;
        this.querySelector('[data-calendar-context]').hidden = isRecurrence || !season;
        this.querySelector('[data-year-round]').hidden = isRecurrence || Boolean(season);
        this.querySelector('[data-formula]').hidden = isRecurrence || !season;
        this.querySelector('[data-calculation-note]').hidden = isRecurrence;
        this.querySelector('[data-assumption]').hidden = isRecurrence;
        if (isRecurrence) {
          this.write('[data-result-heading]', result.recurrence_heading);
          this.write('[data-stat]', this.copy.evidence.hip_value);
          this.write('[data-claim]', this.copy.evidence.hip_label);
          figures.setAttribute('data-mode', 'recurrence');
          figures.removeAttribute('data-long-stat');
          this.querySelector('[data-cap-note]').hidden = true;
          return;
        }
        if (!season) {
          this.write('[data-result-heading]', result.timeframe_heading);
          this.write('[data-stat]', this.copy.evidence[profileId + '_value']);
          this.write('[data-claim]', this.copy.evidence[profileId + '_label']);
          this.write('[data-assumption]', result.year_round_assumption);
          figures.setAttribute('data-mode', 'timeframe');
          figures.removeAttribute('data-long-stat');
          this.querySelector('[data-cap-note]').hidden = true;
          return;
        }

        const length = season.weeks;
        const low = Math.min(100, profile.minWeeks / length * 100);
        const high = Math.min(100, profile.maxWeeks / length * 100);
        const formatNumber = value => String(Math.round(value));
        const percentage = formatNumber(low) + (low === high ? '' : '–' + formatNumber(high)) + '%';
        this.write('[data-result-heading]', result.season_heading);
        this.write('[data-stat]', percentage);
        this.write('[data-claim]', result.season_claim);
        this.write('[data-calendar-basis]', this.copy.calendars[sport + '_basis']);
        this.write('[data-calendar-context]', this.copy.calendars[sport + '_context']);
        const calendarSource = this.querySelector('[data-calendar-source]');
        calendarSource.href = season.source;
        calendarSource.textContent = this.copy.calendars[sport + '_source'];
        this.write('[data-assumption]', result.season_assumption);
        figures.setAttribute('data-mode', 'percentage');
        figures.setAttribute('data-long-stat', String(percentage.length > 7));
        this.querySelector('[data-cap-note]').hidden = profile.maxWeeks <= length;
        this.write('[data-formula]', this.format(result[profileId + '_formula'], {length, percentage}));
      }

      showGuide() {
        const {injury} = this.selection;
        this.querySelector('[data-guide]').hidden = false;
        this.write('[data-guide-title]', this.copy.guide[injury + '_title']);
        this.write('[data-guide-preview]', this.copy.guide.coming_title);
        this.write('[data-guide-link]', this.copy.guide[injury + '_cta']);
        this.querySelector('[data-signup]').hidden = true;
        this.querySelector('[data-guide-preview]').setAttribute('aria-expanded', 'false');
        const guideUrl = injury === 'shin' ? this.dataset.guideShin : this.dataset.guideHip;
        let validGuide = false;
        try {
          const url = new URL(guideUrl, location.origin);
          validGuide = Boolean(guideUrl) && ['https:', 'http:'].includes(url.protocol);
          if (validGuide) this.querySelector('[data-guide-link]').href = url.href;
        } catch { validGuide = false; }
        this.querySelector('[data-guide-link]').hidden = !validGuide;
        this.querySelector('[data-guide-preview]').hidden = validGuide;
      }

      focusResult() {
        this.querySelector('.tic__result-heading').focus({preventScroll: true});
        if (matchMedia('(max-width: 749px)').matches) {
          this.querySelector('[data-result]').scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start'});
        }
      }
    }
    customElements.define('tibhelper-injury-calculator', TibhelperInjuryCalculator);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tibhelper-video-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tibhelper-video-hero')) {
    customElements.define('tibhelper-video-hero', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.control = this.querySelector('.tibhelper-video-hero__motion');
        if (!this.video || !this.control) return;

        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.playAttempt ??= 0;
        this.wantPlaying = false;
        this.video.muted = true;
        this.control.hidden = false;

        this.control.addEventListener('click', () => {
          if (this.wantPlaying) {
            this.playAttempt += 1;
            this.wantPlaying = false;
            this.video.pause();
            this.updateLabel();
          } else {
            this.play();
          }
        }, options);

        this.video.addEventListener('playing', () => {
          if (!this.wantPlaying) {
            this.video.pause();
            return;
          }
          this.setAttribute('data-show-video', '');
          this.updateLabel();
        }, options);

        this.video.addEventListener('pause', () => {
          if (this.video.paused) this.wantPlaying = false;
          this.updateLabel();
        }, options);

        this.video.addEventListener('error', () => this.showStill(), options);
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) this.showStill();
        }, options);

        if (!this.motion.matches && navigator.connection?.saveData !== true) this.play();
      }

      play() {
        const attempt = ++this.playAttempt;
        this.wantPlaying = true;
        if (!this.video.hasAttribute('src')) this.video.src = this.video.dataset.src;
        this.video.play().catch(() => {
          if (attempt === this.playAttempt && this.wantPlaying) this.showStill();
        });
      }

      showStill() {
        this.playAttempt += 1;
        this.wantPlaying = false;
        this.video.pause();
        this.removeAttribute('data-show-video');
        this.updateLabel();
      }

      updateLabel() {
        this.control.textContent = this.video.paused ? this.control.dataset.resumeLabel : this.control.dataset.pauseLabel;
      }

      disconnectedCallback() {
        this.events?.abort();
        if (this.video) this.showStill();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
